document.addEventListener('DOMContentLoaded', () => {
    String.prototype.squish = String.prototype.squish ||
        function () {
            return this.replace(/ {2,}/g, ' ');
        };


    let inputs = document.querySelectorAll('.character-count'),
        str;

    inputs.forEach(function (input) {
        str = "<span><span id='" + input.id + "_characters_counter'>0</span> Charachters</span>";
        input.parentElement.insertAdjacentHTML('beforeend', str);
        input.addEventListener('keyup', function () {
            this.value = this.value.squish();
            this.parentElement.querySelector('#' + this.id + '_characters_counter').innerHTML = this.value.length;
        });
    });


    // let inputs = document.querySelectorAll('.character-count'),
    //     str,
    //     inline_hints,
    //     counter_container;
    //
    // inputs.forEach(function (input) {
    //     inline_hints = input.parentElement.querySelector('.inline-hints')
    //
    //     if (inline_hints === null) {
    //         str = "<span>&nbsp;&nbsp;(<span id='" + input.id + "_characters_counter'>0</span> Charachters)</span>";
    //         counter_container = inline_hints;
    //     } else {
    //         str = "<span><span id='" + input.id + "_characters_counter'>0</span> Charachters</span>";
    //         counter_container = input.parentElement;
    //     }
    //
    //     counter_container.insertAdjacentHTML('beforeend', str);
    //     input.addEventListener('keyup', function () {
    //         this.value = this.value.squish();
    //         this.parentElement.querySelector('#' + this.id + '_characters_counter').innerHTML = this.value.length;
    //     });
    // });
});
